import React from "react";
import {
  Box,
  Button,
  Card,
  Container,
  Grid,
  Stack,
  Typography,
  Breadcrumbs,
} from "@mui/material";
import { motion } from "framer-motion";
import HomeIcon from "@mui/icons-material/Home";
import HotelIcon from "@mui/icons-material/Hotel";
import { Link } from "react-router-dom";

const MotionCard = motion(Card);

const purple = "#4B3FA0";
const purpleLight = "rgba(75,63,160,0.07)";
const purpleBorder = "rgba(75,63,160,0.22)";

const opciones = [
  {
    imagen: "/opcion-hospedaje-1.png",
    accion: "mailto:sgiron@ebg.edu.gt?subject=reserva%20CLADE",
    abrirEn: "_blank",
  },
  {
    imagen: "/opcion-hospedaje-2.png",
    accion:
      "https://www.barcelo.com/es-cr/barcelo-guatemala-city/?eslk=googleads|ng|c396135399270|me|kbarcelo%20guatemala%20city|p|t|dc|a86218535474|g8059190572&id_hotel_sem=7319&utm_source=google&utm_medium=cpc&utm_campaign=8059190572&gad_source=1&gad_campaignid=8059190572&gbraid=0AAAAADpStBNaBUr2O5hbjFzQzbZYnR3sD&gclid=CjwKCAjw857RBhAgEiwAI-1yKLJvj7ljg08LMAJbmyuT1uSgVru5qzFZdCDjP3__o7dvfpCxwmSj1xoCih4QAvD_BwE",
    abrirEn: "_blank",
  },
  {
    nombre: "Holiday Inn",
    descripcion: "Reserva tu habitación para CLADE 2026 en Holiday Inn Guatemala.",
    accion:
      "https://www.ihg.com/redirect?path=rates&brandCode=HI&localeCode=es&regionCode=1&hotelCode=GUACT&checkInDate=19&checkInMonthYear=072026&checkOutDate=22&checkOutMonthYear=072026&_PMID=99801505&GPC=ABG&cn=no&adjustMonth=false&showApp=true&monthIndex=00",
    abrirEn: "_blank",
  },
];

export default function Hospedaje() {
  return (
    <Stack
      spacing={0}
      alignItems="center"
      sx={{ background: "#f4f5f7", width: "100%", minHeight: "100vh" }}
    >
      {/* BREADCRUMB */}
      <Box
        sx={{
          width: "100%",
          pt: 2.5,
          pb: 1,
          px: 3,
          background: "#f4f5f7",
          display: "flex",
          justifyContent: "center",
        }}
      >
        <Breadcrumbs aria-label="breadcrumb" sx={{ fontSize: 15 }}>
          <Link
            to="/"
            style={{
              display: "flex",
              alignItems: "center",
              color: purple,
              textDecoration: "none",
            }}
          >
            <HomeIcon sx={{ mr: 0.5, fontSize: 18 }} />
            Inicio
          </Link>
          <Typography
            sx={{ display: "flex", alignItems: "center", color: "#1e3d52", fontSize: 15 }}
          >
            <HotelIcon sx={{ mr: 0.5, fontSize: 18 }} />
            Opciones de Hospedaje
          </Typography>
        </Breadcrumbs>
      </Box>

      {/* HEADER */}
      <Box
        sx={{
          width: "100%",
          background: `linear-gradient(135deg, #1e3d52 0%, ${purple} 100%)`,
          py: { xs: 5, md: 7 },
          px: 2,
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
        }}
      >
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            gap: 1.5,
            mb: 2,
          }}
        >
          <HotelIcon sx={{ color: "white", fontSize: 36 }} />
          <Typography
            variant="h4"
            sx={{
              color: "white",
              fontWeight: 800,
              letterSpacing: 1,
              textAlign: "center",
            }}
          >
            OPCIONES DE HOSPEDAJE
          </Typography>
        </Box>
        <Typography
          variant="subtitle1"
          sx={{ color: "rgba(255,255,255,0.85)", textAlign: "center", maxWidth: 600 }}
        >
          Selecciona la opción de hospedaje que mejor se adapte a tus necesidades para CLADE 2026.
        </Typography>
      </Box>

      {/* CARDS */}
      <Container maxWidth="lg" sx={{ py: { xs: 4, md: 7 } }}>
        <Grid container spacing={4} justifyContent="center">
          {opciones.map((opcion, index) => (
            <Grid key={index} size={{ xs: 12, sm: 10, md: 6 }}>
              <MotionCard
                whileHover={{ y: -6 }}
                transition={{ type: "spring", stiffness: 260, damping: 20 }}
                sx={{
                  borderRadius: 3,
                  border: `1.5px solid ${purpleBorder}`,
                  background: purpleLight,
                  boxShadow: "none",
                  overflow: "hidden",
                  display: "flex",
                  flexDirection: "column",
                }}
              >
                {/* Imagen de la opción */}
                {opcion.imagen ? (
                  <Box
                    sx={{
                      width: "100%",
                      overflow: "hidden",
                      background: "white",
                    }}
                  >
                    <img
                      onClick={() => window.open(opcion.accion, opcion.abrirEn)}
                      src={opcion.imagen}
                      alt={`Opción de hospedaje ${index + 1}`}
                      style={{ width: "100%", display: "block", objectFit: "cover" }}
                    />
                  </Box>
                ) : (
                  <Box
                    sx={{
                      width: "100%",
                      flex: 1,
                      display: "flex",
                      flexDirection: "column",
                      alignItems: "center",
                      justifyContent: "center",
                      textAlign: "center",
                      gap: 2,
                      p: 4,
                      minHeight: 260,
                    }}
                  >
                    <HotelIcon sx={{ color: purple, fontSize: 48 }} />
                    <Typography
                      variant="h5"
                      sx={{ color: "#1e3d52", fontWeight: 800 }}
                    >
                      {opcion.nombre}
                    </Typography>
                    {opcion.descripcion && (
                      <Typography sx={{ color: "#4a5568", maxWidth: 380 }}>
                        {opcion.descripcion}
                      </Typography>
                    )}
                    <Button
                      variant="contained"
                      size="large"
                      href={opcion.accion}
                      target={opcion.abrirEn}
                      rel="noopener noreferrer"
                      sx={{
                        backgroundColor: purple,
                        color: "white",
                        fontWeight: 700,
                        fontSize: "1rem",
                        letterSpacing: 1.5,
                        px: 5,
                        py: 1.5,
                        borderRadius: 2,
                        textTransform: "uppercase",
                        "&:hover": {
                          backgroundColor: "#3a2f7e",
                        },
                      }}
                    >
                      CLIC AQUÍ
                    </Button>
                  </Box>
                )}

                {/* Botón CLIC AQUÍ 
                <Box
                  sx={{
                    p: 3,
                    display: "flex",
                    justifyContent: "center",
                    background: purpleLight,
                  }}
                >
                  <Button
                    variant="contained"
                    size="large"
                    href={opcion.accion}
                    target={opcion.abrirEn}
                    rel="noopener noreferrer"
                    sx={{
                      backgroundColor: purple,
                      color: "white",
                      fontWeight: 700,
                      fontSize: "1rem",
                      letterSpacing: 1.5,
                      px: 5,
                      py: 1.5,
                      borderRadius: 2,
                      textTransform: "uppercase",
                      "&:hover": {
                        backgroundColor: "#3a2f7e",
                      },
                    }}
                  >
                    CLIC AQUÍ
                  </Button>
                </Box>*/}
              </MotionCard>
            </Grid>
          ))}
        </Grid>
      </Container>
    </Stack>
  );
}
